import { useQuery } from '@tanstack/react-query';
import { getFeaturedCollections } from '@/api/featured-collections';
import type { FeaturedCollectionsResponse } from '@/types/featured-collections';

export function useFeaturedCollections(gameweekId?: string) {
  return useQuery<FeaturedCollectionsResponse>({
    queryKey: ['featured-collections', { gameweekId }],
    queryFn: () => getFeaturedCollections(gameweekId!),
    staleTime: 60_000,
    enabled: !!gameweekId,
  });
}
